<template>
  <button :class="['icon-button', `icon-button-${variant}`]">
    <span class="material-symbols-outlined">
      {{ icon }}
    </span>
    <span
      v-if="text"
      class="icon-button-text"
    >
      {{ text }}
    </span>
  </button>
</template>
<script lang="ts" setup>
//disabled & type as fallthrough attibutes
const {
  variant = 'primary',
  text,
  icon
} = defineProps<{
  text?: string;
  icon: string;
  variant?: 'primary' | 'secondary' | 'destructive' | 'secondary-on-background';
}>();
</script>
<style lang="scss" scoped>
.icon-button {
  border: none;
  background-color: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: $border-radius-md;
  padding: $spacing-3xs;

  .materials-symbols-outlined {
    font-size: $font-size-2xl;
  }
  .icon-button-text {
    font-size: $font-size-3xs;
    font-weight: $font-weight-bold;
  }
}

.icon-button-primary {
  color: $brand-blue;
  &:disabled {
    color: $gray-48;
  }
  &:focus {
    outline: 2px solid $blue-66;
  }
}
.icon-button-secondary {
  color: $brand-black;
  &:disabled {
    color: $gray-48;
  }
  &:focus {
    outline: 2px solid $brand-black;
  }
}

.icon-button-secondary-on-background {
  color: $white;
  &:disabled {
    color: $gray-48;
  }
  &:focus {
    outline: 2px solid $white;
  }
}

.icon-button-destructive {
  color: $red-44;
  &:disabled {
    color: $gray-48;
  }
  &:focus {
    outline: 2px solid $red-44;
  }
}

.icon-button-primary-row,
.icon-button-secondary-row,
.icon-button-destructive-row {
  flex-direction: row;
  align-items: center;
  gap: $spacing-4xs;
  .materials-symbols-outlined {
    font-size: $font-size-xl;
  }
  .icon-button-text {
    font-size: $font-size-xs;
    font-weight: $font-weight-bold;
  }
}
</style>
